import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import common_helper from '../../../../common_helper'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'auditdiscrepancyreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		Loader,
		BasicSelect
	},
	data() {
		return {
			listMerchantIdData: [],
			merchantnameFlt: '',
			Aprovedids2: [],
			isdisableForDate: false,
			updateddate: '',
			selectAll: false,
			checkallflag: true,
			Aprovedids: [],
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listAuditData: [],
			listAuditDatacsv: [],
			displayMsg: false,
			successErrorMsg: "",
			fromDateFlt: "",
			toDateFlt: "",
			// totalPage: 0,
			// pageNo: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			loginuserid: '',
			isLoading: false,
			// perPage: 10,
			formattedDate: '',
			user_type: '',
			productid: '',
			rackid: '',
			resultCount: 0,
			userid: '',
			useremail: '',
			show: false,
			download: true,
			dataFilter2: '',
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			configLimit: 0,
			item: {},
			listMerchantData1: [],
			merchantList: [],
			sessiontime: '',
			audittime: '',
			excessqty: '',
			excessprodqty: '',
			i: {},
			excessqtyflag: false,
			excessprodqtyflag: false,
			checkFlag: false,
			configData: [],
			AuditTimeOutFlag: false,
		}
	},
	filters: {
		moment: function (dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction()
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.useremail = userdetail.email;

		this.loginuserid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.pageNo = 0;
		this.reportname = this.$t('auditReport.auditDiscrepancyFileName')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('YYYY/MM/DD HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantData();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;
			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
		// this.getConfigLimitForID();

	}, // End computed
	methods: {
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromDateFlt = dt;
		},
		async getMerchantData() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			let result = await common_helper.getRestApiResponse('POST', 'merchantList', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data && result.data.length > 0) {
					this.listMerchantData = result.data;
					this.item = {
						value: '',
						text: ''
					};
					this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }];
					this.listMerchantData.forEach(ele => {
						this.listMerchantData1.push({
							"value": ele.merchantid,
							"text": ele.merchantname
						})
					})

				}
			}

		},
		reset() {
			this.item = {}
		},
		onSelect(item) {
			this.item = item
			this.merchantnameFlt = item.value
		},
		async getConfigLimitForID() {
			this.input = ({
			})
			let result = await common_helper.getRestApiResponse('POST', 'merchantList', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data) {
					this.configLimit = 3;
				}
			}

		},

		selectAllCheckbox: function () {
			if (this.checkallflag == true) {
				this.Aprovedids = [];
				if (this.selectAll) {
					// for (let [data, order] in ) {
					this.listAuditData.forEach((data, order) => {
						if (this.listAuditData[order].checkFlag != true) {

						} else {
							if (this.listAuditData[order].excessqty == 0 && this.listAuditData[order].excessproduct == 0 && this.listAuditData[order].flag == true) {
								this.Aprovedids.push(this.listAuditData[order].id);
							}
							if (this.listAuditData[order].excessqty > 0 && this.excessqtyflag == false && this.listAuditData[order].flag == true) {
								this.Aprovedids.push(this.listAuditData[order].id);
							}
							if (this.listAuditData[order].excessproduct > 0 && this.excessprodqtyflag == false && this.listAuditData[order].flag == true) {
								this.Aprovedids.push(this.listAuditData[order].id);
							}
							this.Aprovedids.indexOf(this.listAuditData[order].id) == -1
							setInterval(function () {
								window.location.reload();
							}, 180000);
						}
					})
				} else {
					this.Aprovedids = [];
				}
			} else {
				this.$alertify.error(this.$t('common.disabledError'));
			}
		},
		async ApproveIDS() {
			this.ifclosed = true;
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehouse
			}
			for (var i = 0; i < this.listAuditData.length; i++) {
				for (var j = 0; j < this.Aprovedids.length; j++) {
					if (this.Aprovedids[j] == this.listAuditData[i].id) {
						if (this.Aprovedids2.indexOf(this.Aprovedids[j]) == -1)
							this.Aprovedids2.push({
								'id': this.listAuditData[i].id,
								'excessqty': this.listAuditData[i].excessqty,
								'shortqty': this.listAuditData[i].shortqty,
								'excessproduct': this.listAuditData[i].excessproduct,
								'defaultval': this.listAuditData[i].defaultval,

							});
						console.log(this.Aprovedids2);

					}
					// if (this.Aprovedids2.indexOf(this.listAuditData[j]) == -1){


				}
			}
			if (this.Aprovedids2.length == 0) {
				this.$alertify.error(this.$t('common.rackIdApprovalError'));
				return false;

			}
			this.isLoading = true;
			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				userid: this.useremail,
				IDDetails: this.Aprovedids2,

			});
			let result = await common_helper.getRestApiResponse('POST', 'saveapprovedRackAudit', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				this.isLoading = false;
				if (result.data.errorCode == 0) {
					this.$alertify.success(result.data.msg)
					this.getAuditList()
				} else if (result.data.errorCode == -1) {
					this.$alertify.error(result.data.msg)
					this.getAuditList()
				}
			}

		},

		Timerout: function () {
			this.listAuditData = this.listAuditData.map((ele, index) => {
				let today1 = new Date();
				let GMT00 = ele.updateddate;

				let GMT = new Date(GMT00)
				let Hours = this.configData[0].defaultval;

				const newDate1 = this.addHours(GMT, Number(Hours))

				let newDate = moment(newDate1).unix()
				let today = moment(today1).unix()
				if (newDate < today) {
					ele.flag = false;
					this.AuditTimeOutFlag = true;
				}
				else {
					ele.flag = true
					this.AuditTimeOutFlag = false
				}
				return ele

			})
		},
		addHours(date, hours) {
			const newDate = new Date(date)
			newDate.setHours(newDate.getHours() + hours);
			return newDate;
		},
		async getRecordLimit() {
			this.input = ({
			})
			let result = await common_helper.getRestApiResponse('POST', 'getRecordLimit', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (result.data) {
					this.recordLimit = result.data.data;
				}
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)


			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.Aprovedids = [];
				this.selectAll = false;
			} else { }
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		// async getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}
		// 		let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listClientData = result.data.data;
		// 		}
		// 	}
		// },

		// async getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		let result = await common_helper.getRestApiResponse('POST', 'getClientAssociatedWarehouseList', this.input, this.$alertify)
		// 		if (result && !result.errorDATA) {
		// 			this.listWarehouseData = result.data.data;
		// 		}

		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantData();

		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getMerchantData();
		// 				//this.getAuditList();
		// 			}
		// 		}
		// 	}
		// 	this.listAuditData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getconfig() {
			this.input = {
				type: 'rackaudit',
				warehouseidlocal: localStorage.getItem("selectedWarehouse"),
				localclientid: localStorage.getItem("selectedClient"),
			}
			let response = await common_helper.getRestApiResponse('POST', 'getconfig1', this.input, this.$alertify)
			if (response && !response.errorDATA) {

				this.configData = response.data;
				this.Timerout();

				if (response.data[0].maxval == 'yes') {
					this.excessprodqtyflag = false;
				}
				else {
					this.excessprodqtyflag = true;
				}
				if (response.data[0].maximumvalue == 'yes') {
					this.excessqtyflag = false;
				}
				else {
					this.excessqtyflag = true;
				}

			}

		},

		async getAuditList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			var dataFilter = {};
			this.selectAll = '';
			this.Aprovedids = [];
			this.Aprovedids2 = [];
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listRackinData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listRackinData = [];
				return false;
			}
			this.isLoading = true;
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			let result = await common_helper.getRestApiResponse('POST', 'getRackAuditDetailsFordescripency', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (csvCheck == 1) {
					if (result.data.data.length > 0) {
						this.listAuditDatacsv = [];
						this.show = true;
						this.download = false;
						this.csvFields = {
							'rackid': this.$t('common.rackID'),
							'productid': this.$t('common.productId'),
							'eancode': this.$t('common.eanCode'),
							'systemqty': this.$t('auditReport.systemQty'),
							'scannedqty': this.$t('auditReport.scannedQty'),
							'matchedqty': this.$t('auditReport.matchQty'),
							'excessqty': this.$t('common.excessQty'),
							'excessproduct': this.$t('auditReport.excessProductQty'),
							'shortqty': this.$t('common.shortQty'),
							'createddate': this.$t('auditReport.auditStartDate'),
							'updateddate': this.$t('auditReport.auditCompletedDate'),
							'userid': this.$t('auditReport.auditBy'),
							'id': this.$t('common.id'),
							'sessionid': this.$t('auditReport.sessionId'),
							'merchantname': this.$t('common.merchant'),

						};
						var dateFilter = ['updateddate', 'createddate'];
						var skipFilter = ['merchantid', 'isapproved', 'newrackstock'];
						this.listAuditDatacsv = [];
						this.listAuditDatacsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('auditReport.auditDiscrepancyFileName'), this.listAuditDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('RackAuditReportDetailed', this.listAuditDatacsv, this.csvFields, dateFilder, skipFilter);
					} else {
						if (result.data.status == true) {
							this.$alertify.success(this.$t('common.reportSizeError'));
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}
				} else {
					this.listAuditData = result.data.data;
					this.getconfig();
					if (result.data.errorCode == -1) {
						this.resultCount = 0;
						this.totalRows = 0;
						this.$alertify.error(result.data.msg);
					} else {
						this.totalRows = result.data.count
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						this.resultCount = result.data.count
						if (this.totalRows == 0) {
							this.totalPage = 0
						} else if (this.totalRows < 10) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / 10)
						}
					}
				}
				this.isLoading = false;
			}
		},


		async getAuditListForXLS(csvCheck = 0) {
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				productid: this.productid,
				rackid: this.rackid,
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchantnameFlt


			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			let result = await common_helper.getRestApiResponse('POST', 'getRackAuditDetailsFordescripency', this.input, this.$alertify)
			if (result && !result.errorDATA) {
				if (csvCheck == 3) {
					if (result.data.data.length > 0) {
						this.listStockReportDataforxls = [];
						this.csvFieldsForXls[this.$t('common.rackID')]='rackid';
						this.csvFieldsForXls[this.$t('common.productId')]='productid';
						this.csvFieldsForXls[this.$t('common.eanCode')]='eancode';
						this.csvFieldsForXls[this.$t('auditReport.systemQty')]='systemqty';
						this.csvFieldsForXls[this.$t('auditReport.scannedQty')]='scannedqty';
						this.csvFieldsForXls[this.$t('auditReport.matchQty')]='matchedqty';
						this.csvFieldsForXls[this.$t('common.excessQty')]='excessqty';
						this.csvFieldsForXls[this.$t('common.shortQty')]='shortqty';
						this.csvFieldsForXls[this.$t('auditReport.auditStartDate')]='createddate';
						this.csvFieldsForXls[this.$t('auditReport.auditCompletedDate')]='updateddate';
						this.csvFieldsForXls[this.$t('auditReport.auditBy')]='userid';
						this.csvFieldsForXls[this.$t('common.id')]='id';
						this.csvFieldsForXls[this.$t('auditReport.sessionId')]='sessionid';
						this.csvFieldsForXls[this.$t('common.merchant')]='merchantname';

						this.listStockReportDataforxls = result.data.data;

					} else {
						this.getconfig();
						if (result.data.status == true) {
							this.$alertify.success(this.$t('common.reportSizeError'));
						} else {
							this.$alertify.error(result.data.msg.message);
						}
					}
				}
			}
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getAuditList(2);
		},
		AuditListing() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getAuditList(2);
		},
		resetAuditSerach() {
			this.isLoadingforxls = false;
			this.show = false;
			this.download = true;
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.listAuditData = [];
			this.pageNo = 0;
			this.clientid = '';
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = false;
			this.rackid = '';
			this.productid = '';
			this.merchantnameFlt = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			// this.getAuditList();
		},
		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	} // end methods

}


// WEBPACK FOOTER //
// ./src/views/components/reports/auditdiscrepancyreport/auditdiscrepancyreport.component.js